import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, map } from "rxjs";
import { Project } from "src/app/class/project";
import { ProjectAdjustment } from "src/app/class/project-adjustment";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class ProjectService {
  constructor(private http: HttpClient) { }

  // ------------------------------ Get ------------------------------
  findProjectPaginationWithSorting(
    offset: number,
    pageSize: number,
    field: string,
    isAscending: boolean,
    keyword: string
  ): Observable<any> {
    let params = new HttpParams();
    if (isAscending != null) {
      params = params.append("isAscending", isAscending);
    }
    if (keyword != null) {
      // const keywordString = keyword.join(',');
      params = params.append("keyword", keyword);
    }
    return this.http.get<any[]>(
      `${environment.url}/apiProject/findProjectPaginationWithSorting/${offset}/${pageSize}/${field}`,
      { params: params }
    );
  }

  
  updateProjectIsDelete(id: number, isDelete: boolean): Observable<any> {
    let params = new HttpParams();
    if (isDelete != null) {
      params = params.append("isDelete", isDelete);    
    }
    return this.http.put<any>(
      `${environment.url}/apiProject/updateIsDelete/${id}?isDelete=${isDelete}`, { params: params}
    );
  }

  


  findProjectPaginationWithSortingV2(
    offset: number,
    pageSize: number,
    field: string,
    isAscending: boolean,
    searchText: string,
    active: boolean
  ): Observable<any> {
    let params = new HttpParams();
    if (isAscending != null) {
      params = params.append("isAscending", isAscending);
    }
    if (searchText != null) {
      params = params.append("searchText", searchText);
    }
    if (active != null) {
      params = params.append("active", active);
    }
    return this.http.get<any[]>(
      `${environment.url}/apiProject/findProjectPaginationWithSortingV2/${offset}/${pageSize}/${field}`, { params: params }
    );
  }

  findProjectFilterPagingWithManager(
    offset: number,
    pageSize: number,
    field: string,
    isAscending: boolean,
    searchText: string,
    managerId : number,
    active?: boolean
  ): Observable<any> {
    let params = new HttpParams();
    if (isAscending != null) {
      params = params.append("isAscending", isAscending);
    }
    if (searchText != null) {
      params = params.append("searchText", searchText);
    }
    if (managerId != null) {
      params = params.append("managerId", managerId);
    }
    if (active != null) {
      params = params.append("active", active);
    }
    return this.http.get<any[]>(
      `${environment.url}/apiProject/findProjectFilterPagingWithManager/${offset}/${pageSize}/${field}`, { params: params }
    );
  }

  getProjectAll(): Observable<any> {
    return this.http.get<any>(`${environment.url}/apiProject/getProjectAll`);
  }

  getProjectAllforSearch(): Observable<any> {
    return this.http
      .get<any>(`${environment.url}/apiProject/getProjectAll`)
      .pipe(map((res: []) => res.map((item) => item["projectName"])));
  }

  public getAllLeader() {
    return this.http.get<any[]>(
      `${environment.url}/apiMsPosition/getAllLeader`
    );
  }

  public getAdjustment(projectId: number) {
    return this.http.get<any>(
      `${environment.url}/apiProjectAdjustment/getAdjustment/${projectId}`
    );
  }

  public getAllAdjustment() {
    return this.http.get<any>(
      `${environment.url}/apiProjectAdjustment/getAllAdjustment`
    );
  }

  getProjectAdjustmentPagination(
    pageNo: number,
    pageSize: number,
    field: string,
    isAscending: boolean,
    nowTab: string,
    keyword: string
  ): Observable<any> {
    let params = new HttpParams();
    if (isAscending != null) {
      params = params.append("isAscending", isAscending);
    }
    if (keyword != null) {
      params = params.append("keyword", keyword);
    }
    return this.http.get<any[]>(
      `${environment.url}/apiProjectAdjustment/getProjectAdjustmentPagination/${pageNo}/${pageSize}/${field}/${nowTab}`,
      { params: params }
    );
  }

  // ------------------------------ Post ------------------------------
  addNewProject(project: Project): Observable<any> {
    console.log("LOG +++++", project);
    return this.http.post<any>(
      `${environment.url}/apiProject/addProject`,
      project
    );
  }

  addProjectAdjustment(
    adjustType: string,
    projectAdjust: ProjectAdjustment
  ): Observable<any> {
    return this.http.post<any>(
      `${environment.url}/apiProjectAdjustment/addProjectAdjustment/${adjustType}`,
      projectAdjust
    );
  }

  // ------------------------------ PUT ------------------------------
  updateProject(project: Project): Observable<any> {
    return this.http.put<any>(
      `${environment.url}/apiProject/updateProject`,
      project
    );
  }

  updateProjectAdjustment(projectAdjust: ProjectAdjustment): Observable<any> {
    return this.http.put<any>(
      `${environment.url}/apiProjectAdjustment/updateProjectAdjustment`,
      projectAdjust
    );
  }

  updateProjectAdjustmentStatus(project: ProjectAdjustment): Observable<any> {
    return this.http.put<any>(
      `${environment.url}/apiProjectAdjustment/updateProjectAdjustment`,
      project
    );
  }

  // ------------------------------ DELETE ------------------------------
  deleteProject(id: number): Observable<any> {
    return this.http.delete<any>(
      `${environment.url}/apiProject/deleteProject?Id=${id}`
    );
  }

  getRecentProject() {
    return this.http.get<any>(
      `${environment.url}/apiProject/getRecentProject`
    );
  }

  updateProjectEndDate(id: number, endDate: Date): Observable<any> {
    const body = { endDate };
    return this.http.put<any>(
      `${environment.url}/apiProject/updateProjectEndDate?id=${id}`,
      body
    );
  }
getProjectById(id: number): Observable<Project> {
  return this.http.get<Project>(`${environment.url}/apiProject/getProjectById/${id}`);
}
  getProjectAdjustmentByType(nowTab: string): Observable<any> {
    return this.http
      .get<any>(`${environment.url}/apiProjectAdjustment/getProjectAdjustmentByType/${nowTab}`)
      .pipe(map((res: []) => res.map((item) => item["projectId"])));
  }

  getProjectRemainingManday(id: number) {
    let params = new HttpParams();
    if (id != null) {
      params = params.append("id", id);
    }
    return this.http.get<any>(
      `${environment.url}/apiProject/findProjectRemainingMandayById`, {params: params}
    );


  }
}
